import { useTranslation } from "react-i18next";

const Schedule = () => {
  const { t } = useTranslation();

  return (
    <section className="w-10/12 md:w-1/2 lg:w-2/6 max-w-[400px] lg:min-h-[440px] px-6 py-6 flex justify-center items-center bg-gradient shadow-lg">
      <div className="flex flex-col flex-1">
        <h2 className="text-2xl font-bold text-center mb-4">{t("schedule.title")}</h2>
        <table className="table-auto w-full text-left text-sm md:text-lg">
          <tbody>
            <tr className="odd:bg-odd-table-gray">
              <td className="p-2 font-medium">{t("schedule.days.monday")}</td>
              <td className="p-2 text-right">{t("schedule.closed")}</td>
            </tr>
            <tr className="odd:bg-odd-table-gray">
              <td className="p-2 font-medium">{t("schedule.days.tuesday")}</td>
              <td className="p-2 text-right">09:30 - 19:00</td>
            </tr>
            <tr className="odd:bg-odd-table-gray">
              <td className="p-2 font-medium">{t("schedule.days.wednesday")}</td>
              <td className="p-2 text-right">09:30 - 19:00</td>
            </tr>
            <tr className="odd:bg-odd-table-gray">
              <td className="p-2 font-medium">{t("schedule.days.thursday")}</td>
              <td className="p-2 text-right">13:00 - 21:00</td>
            </tr>
            <tr className="odd:bg-odd-table-gray">
              <td className="p-2 font-medium">{t("schedule.days.friday")}</td>
              <td className="p-2 text-right">09:30 - 19:00</td>
            </tr>
            <tr className="odd:bg-odd-table-gray">
              <td className="p-2 font-medium">{t("schedule.days.saturday")}</td>
              <td className="p-2 text-right">09:00 - 18:00</td>
            </tr>
            <tr className="odd:bg-odd-table-gray">
              <td className="p-2 font-medium">{t("schedule.days.sunday")}</td>
              <td className="p-2 text-right">{t("schedule.closed")}</td>
            </tr>
          </tbody>
        </table>
        <p className="mt-4 text-sm text-center">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://wa.me/message/LGAT32OFGN5VO1"
            className="hover:underline"
          >
            {t("schedule.info")} <span className="font-bold">011.056.7285</span>
          </a>
        </p>
      </div>
    </section>
  );
};

export default Schedule;
